import './markdown-toc.scss';

import { components } from 'gridstrap/lib/gs-components';

import { GSMarkdownTOC } from './markdown-toc';


components.register({
	selector: '.gs-MarkdownTOC',
	controller: GSMarkdownTOC
});
